module.exports = __webpack_public_path__ + "static/media/sign_up_step_2.53dc8cdb.svg";